import { Stack } from "@mui/material";

import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { RegistrationRequestsTable } from "RegistrationRequests/Components/RegistrationRequestsTable";
import { AuthenticatedLayout } from "Shared/Layouts/AuthenticatedLayout";

export const RegistrationRequestsPage = (): React.ReactNode => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      preTitle={t(Resources.Common.Admin)}
      title={t(Resources.Common.RegistrationRequests)}
    >
      <Stack spacing={Spacing.L}>
        <RegistrationRequestsTable />
      </Stack>
    </AuthenticatedLayout>
  );
};
